import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import styles from "./ChannelURLHelper.module.scss";

const ChannelURLHelper: React.FC = () => {
  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  const handleModal = (value: boolean) => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = value ? "hidden" : "unset";
    }

    setIsModalShown(value);
  };

  useEffect(() => {
    return () => {
      const html = document.querySelector("html");
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, []);
  return (
    <>
      <button
        type="button"
        onClick={() => {
          handleModal(true);
        }}
        className={styles["youtube-helper"]}
      >
        <FontAwesomeIcon
          icon={["fal", "question-circle"]}
          className={styles["g-header__icon"]}
        />
        <span>チャンネルURLに関して</span>
      </button>

      {isModalShown === true ? (
        <div className={styles["youtube-helper-modal-wrapper"]}>
          <div className={styles["youtube-helper-modal"]}>
            <i
              className={styles["youtube-helper-modal__close"]}
              onClick={() => {
                handleModal(false);
              }}
            >
              <FontAwesomeIcon icon={["fas", "times"]} />
            </i>
            <div className={styles["youtube-helper-modal__description"]}>
              <p>自身のYouTubeチャンネルのURLをご入力ください。</p>
              <p>
                URLは末尾にチャンネルIDの付く
                <a
                  href="https://support.google.com/youtube/answer/6180214"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  チャンネルの標準のURL
                </a>
                をご入力ください。
              </p>
              <p>
                チャンネルURLは
                <a
                  href="http://youtube.com/handle"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  こちら
                </a>
                で確認できます。
              </p>
              <p>
                {`もしくは\n`}
                <a
                  href="http://studio.youtube.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  YouTube Studio
                </a>
                {`にログイン後\n`}
                {`[カスタマイズ] → [基本情報]\nで確認することができます。`}
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ChannelURLHelper;
